import React, { useState } from "react";
import styled from "styled-components";
import { FiX } from "react-icons/fi";

// Sample images (replace these URLs with your own)
const images = [
  "https://cdn.shopify.com/s/files/1/0851/4607/5431/files/WhatsApp_Image_2026-01-07_at_11.42.28_1.jpg?v=1767812958",
  "https://cdn.shopify.com/s/files/1/0851/4607/5431/files/WhatsApp_Image_2026-01-07_at_11.42.27.jpg?v=1767812958",
  "https://cdn.shopify.com/s/files/1/0851/4607/5431/files/WhatsApp_Image_2026-01-07_at_11.42.26_1.jpg?v=1767812958",
  "https://cdn.shopify.com/s/files/1/0851/4607/5431/files/WhatsApp_Image_2026-01-07_at_11.42.26.jpg?v=1767812958",
];

const Gallery = () => {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState(null);

  const openLightbox = (img) => {
    setCurrentImage(img);
    setLightboxOpen(true);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    setCurrentImage(null);
  };

  return (
    <Wrapper>
      <Title>Our Gallery</Title>
      <GalleryGrid>
        {images.map((img, idx) => (
          <ImageCard key={idx} onClick={() => openLightbox(img)}>
            <img src={img} alt={`Gallery ${idx + 1}`} />
            <Overlay>View</Overlay>
          </ImageCard>
        ))}
      </GalleryGrid>

      {lightboxOpen && (
        <Lightbox onClick={closeLightbox}>
          <CloseIcon onClick={closeLightbox}>
            <FiX size={28} />
          </CloseIcon>
          <LightboxImage src={currentImage} alt="Gallery Lightbox" />
        </Lightbox>
      )}
    </Wrapper>
  );
};

export default Gallery;

// ---------------- Styled Components ----------------

const Wrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 80px 20px 60px;
  color: ${(props) => props.theme.colors.dark};
`;

const Title = styled.h1`
  text-align: center;
  font-size: 2.5rem;
  color: ${(props) => props.theme.colors.secondary};
  margin-bottom: 50px;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const GalleryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
`;

const ImageCard = styled.div`
  position: relative;
  cursor: pointer;
  overflow: hidden;
  border-radius: 12px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.05);
  }

  img {
    width: 100%;
    height: 200px;
    object-fit: cover;
    display: block;
    transition: transform 0.3s ease;
  }
`;

const Overlay = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-weight: bold;
  font-size: 1.2rem;
  background: rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: opacity 0.3s ease;

  ${ImageCard}:hover & {
    opacity: 1;
  }
`;

const Lightbox = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  padding: 20px;
`;

const LightboxImage = styled.img`
  max-width: 90%;
  max-height: 90%;
  border-radius: 12px;
`;

const CloseIcon = styled.div`
  position: absolute;
  top: 30px;
  right: 30px;
  color: #fff;
  cursor: pointer;
  z-index: 2100;

  &:hover {
    color: #f7ad2b;
  }
`;
